import ContactItem from './modules/contact-form.js';

window.addEventListener('load',()=>{
  const contactItem = new ContactItem();

  contactItem.obj = {
    title: 'お名前',
    type: 'text',
    name: 'zaty_name',
    example: '例）田中　一郎',
    required: true,
  }
  contactItem.render(S('.jsZatyContactName'));

  contactItem.obj = {
    title: 'フリガナ',
    name: 'zaty_furi',
    example: '例）タナカ　イチロウ',
    required: true,
  }
  contactItem.render(S('.jsZatyContactFri'));

  contactItem.obj = {
    title: 'メールアドレス',
    name: 'zaty_mail',
    example: '例）official@examle.com',
    required: true,
    note: null,
    err: true,
    error : {
      match: /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/g,
      text: '正しく入力できていません'
    }
  }
  contactItem.render(S('.jsZatyContactMail'));

  contactItem.obj = {
    title: '会社名',
    name: 'zaty_group',
    example: '例）ZATY WEB制作事務所',
    required: false,
    err: false,
  }
  contactItem.render(S('.jsZatyContactGroup'));

  contactItem.obj = {
    title: '電話番号',
    name: 'zaty_tel',
    example: '例）09001234567',
    required: false,
    note: 'ハイフンなしで入力してください',
    err: true,
    error : {
      match: /^\d{8,12}$/g,
      text: '正しく入力できていません'
    }
  }
  contactItem.render(S('.jsZatyContactTel'));

  contactItem.obj = {
    title: 'お問い合わせ内容',
    type: 'textarea',
    name: 'zaty_content',
    note: null,
    example: null,
    required: true,
    err: false,
  }
  contactItem.render(S('.jsZatyContactContent'));

  contactItem.obj = {
    title: 'privacy',
    name: 'zaty_privacy',
    type: 'checkbox',
    label: '個人情報の取り扱いに同意する',
  }
  contactItem.create.checkbox(S('.jsPrivacyCheckbox'));

  if(S('.jsConfirm'))
  {
    S('.jsConfirm').addEventListener('click', e =>{
      const target = e.currentTarget;
      contactItem.buttonClick(e, target, 'confirm');
    });
    S('input[name="zaty_privacy"]').addEventListener('click', e => {
      S('.jsConfirmEl').classList.toggle('contact-area__confirm--checked');
    });
  }
});
